module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-hover.6c2c8836.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-hover.png
// module id = 3405
// module chunks = 11